/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {AbstractControl} from '../model';
import {AsyncValidator, AsyncValidatorFn, Validator, ValidatorFn} from './validators';
/**
 * @param {?} validator
 * @return {?}
 */
export function normalizeValidator(validator: ValidatorFn | Validator): ValidatorFn {
  if (( /** @type {?} */((<Validator>validator))).validate) {
    return (c: AbstractControl) => ( /** @type {?} */((<Validator>validator))).validate(c);
  } else {
    return /** @type {?} */(( <ValidatorFn>validator));
  }
}
/**
 * @param {?} validator
 * @return {?}
 */
export function normalizeAsyncValidator(validator: AsyncValidatorFn | AsyncValidator):
    AsyncValidatorFn {
  if (( /** @type {?} */((<AsyncValidator>validator))).validate) {
    return (c: AbstractControl) => ( /** @type {?} */((<AsyncValidator>validator))).validate(c);
  } else {
    return /** @type {?} */(( <AsyncValidatorFn>validator));
  }
}
